export default __webpack_public_path__ + "static/dot-pattern-olive-group-mobile-6962d2a680e9f6b6d0cf27c876e2eac0.svg";